if (!customElements.get('pb-announcement-carousel')) {
  customElements.define('pb-announcement-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.items = Array.from(this.querySelectorAll('[data-pbab-item]'));
      this.stack = this.querySelector('[data-pbab-stack]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.editor = this.dataset.designMode === 'true';
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Math.max(5, Math.min(12, Number(this.dataset.interval) || 8)) * 1000;
      this.hovered = false;
      this.focused = this.contains(document.activeElement);
      this.cleanup = [];
      this.listen(this, 'mouseenter', () => { this.hovered = true; this.sync(); });
      this.listen(this, 'mouseleave', () => { this.hovered = false; this.sync(); });
      this.listen(this, 'focusin', () => { this.focused = true; this.sync(); });
      this.listen(this, 'focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.sync(); });
      this.listen(document, 'visibilitychange', () => this.sync());
      this.listen(this.motion, 'change', () => this.sync());
      this.listen(this.querySelector('[data-pbab-previous]'), 'click', () => this.manual(-1));
      this.listen(this.querySelector('[data-pbab-next]'), 'click', () => this.manual(1));
      this.listen(this, 'shopify:block:select', (event) => {
        const index = this.items.findIndex((item) => item.dataset.blockId === event.detail?.blockId);
        if (index < 0) return;
        this.show(index);
        this.sync();
      });
      this.show(Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active'))));
      this.dataset.pbabReady = 'true';
      this.sync();
    }

    listen(target, type, callback) {
      if (!target) return;
      target.addEventListener(type, callback);
      this.cleanup.push(() => target.removeEventListener(type, callback));
    }

    show(index) {
      if (!this.items.length) return;
      this.index = (index + this.items.length) % this.items.length;
      this.items.forEach((item, position) => {
        const active = position === this.index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', String(!active));
        item.inert = !active;
        item.querySelectorAll('a[href]').forEach((link) => {
          if (active) link.removeAttribute('tabindex');
          else link.setAttribute('tabindex', '-1');
        });
      });
    }

    manual(direction) {
      this.show(this.index + direction);
      this.sync();
    }

    sync() {
      clearInterval(this.timer);
      this.timer = null;
      if (!this.bound || !this.isConnected) return;
      const enabled = this.autoplay && !this.editor && !this.motion.matches && this.items.length > 1;
      const rotating = enabled && !this.hovered && !this.focused && !document.hidden;
      this.stack?.setAttribute('aria-live', rotating ? 'off' : 'polite');
      if (rotating) this.timer = setInterval(() => this.show(this.index + 1), this.interval);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.timer = null;
      this.bound = false;
      this.cleanup?.forEach((remove) => remove());
      this.cleanup = [];
    }
  });
}
